var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#4F46E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3333 11.8335H13.3333C12.4166 11.8335 11.6666 12.5835 11.6666 13.5002V25.1668H13.3333V13.5002H23.3333V11.8335ZM25.8334 15.1672H16.6667C15.7501 15.1672 15.0001 15.9172 15.0001 16.8339V28.5006C15.0001 29.4172 15.7501 30.1672 16.6667 30.1672H25.8334C26.7501 30.1672 27.5001 29.4172 27.5001 28.5006V16.8339C27.5001 15.9172 26.7501 15.1672 25.8334 15.1672ZM16.6666 28.5002H25.8333V16.8335H16.6666V28.5002Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.668b9141b3ffce2f8966fa420356929e.svg";
export { ForwardRef as ReactComponent };